// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pm-list-item-template[data-v-c01dd9aa] {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.pm-list-item-template .index[data-v-c01dd9aa] {\n  flex: 1;\n}\n.box-bubble[data-v-c01dd9aa] {\n  border: 1px solid #cfcdcd;\n  padding: 10px;\n  border-radius: 10px;\n}", ""]);
// Exports
module.exports = exports;
